import React, {useEffect, useState} from "react";
import Button from "../../../components/button";
import Breadcrumbs from "../../../components/breadcrumbs";
import Input from "../../../components/input";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useParams} from "react-router-dom";
import {
    searchWorkActivity,
    updateWorkActivity,
    clear_work_activity,
    UPDATE_WORK_ACTIVITY,
    CREATE_WORK_ACTIVITY_TEAM,
    createWorkActivityTeam,
    deleteWorkActivityTeam,
    DELETE_WORK_ACTIVITY_TEAM
} from "../../../redux/work_activities";
import SelectInput from "../../../components/select";
import Footer from "../../../components/footer";
import {Switch, Space} from "antd";
import LoadingSpinner from "../../../components/loading-spinner";
import Modal from "../../../components/modal";
import { getAllWorkSheets } from "../../../redux/work_sheets";
import {
    clear_work_activity_aditional_data,
    CREATE_WORK_ACTIVITY_ADITIONAL_DATA,
    createWorkActivityAditionalData,
    DELETE_WORK_ACTIVITY_ADITIONAL_DATA,
    deleteWorkActivityAditionalData
} from "../../../redux/work_activity_aditional_data";
import {
    clear_work_activity_template,
    CREATE_WORK_ACTIVITY_TEMPLATE,
    createWorkActivityTemplate,
    DELETE_WORK_ACTIVITY_TEMPLATE,
    deleteWorkActivityTemplate,
    UPDATE_WORK_ACTIVITY_TEMPLATE,
    updateWorkActivityTemplate,
} from "../../../redux/work_activity_templates";
import Select from "react-select";
import TextArea from "../../../components/text-area";

const UpdateWorkActivity = () => {
    let history = useHistory();
    const {id_work_sheet, id_work_process, id_work_subprocess, id} = useParams();

    const dispatch = useDispatch();
    const {token} = useSelector((state) => state.users_module.login.data) || null;
    const _get_all_critical_levels = useSelector((state) => state.critical_levels_module._get_all_critical_levels);
    const _get_all_teams = useSelector((state) => state.teams_module._get_all_teams);
    const _update_work_activity = useSelector((state) => state.work_activities_module._update_work_activity);
    const _create_work_activity_team = useSelector((state) => state.work_activities_module._create_work_activity_team);
    const _delete_work_activity_team = useSelector((state) => state.work_activities_module._delete_work_activity_team);
    const _create_work_activity_aditional_data = useSelector((state) => state.work_activity_aditional_data_module._create_work_activity_aditional_data);
    const _delete_work_activity_aditional_data = useSelector((state) => state.work_activity_aditional_data_module._delete_work_activity_aditional_data);
    const _create_work_activity_template = useSelector((state) => state.work_activity_templates_module._create_work_activity_template);
    const _update_work_activity_template = useSelector((state) => state.work_activity_templates_module._update_work_activity_template);
    const _delete_work_activity_template = useSelector((state) => state.work_activity_templates_module._delete_work_activity_template);

    const [isLoading, setIsLoading] = useState(false);
    const [modalAditionalData, setModalAditionalData] = useState(false);
    const [modalTemplate, setModalTemplate] = useState(false);
    const [modalTeam, setModalTeam] = useState(false);
    const [criticalLevels, setCriticalLevels] = useState([]);
    const [aditionalData, setAditionalData] = useState('');
    const [id_archivo, setIdArchivo] = useState(0);
    const [nombre_archivo, setNombreArchivo] = useState('');
    const [archivo, setArchivo] = useState('');

    const [form, setForm] = useState({
        nombre: "",
        id_subproceso_trabajo: 0,
        subproceso_trabajo: "",
        id_nivel_critico: 0,
        nivel_critico: "",
        descripcion: "",
        puntos_critico: 0,
        id_tipo_usuario: 0,
        activo: true,
        impacto_riesgo: false,
        equipos: [],
        datos_adicionales: [],
        archivos: [],
    });

    useEffect(() => {
        if (_get_all_critical_levels.data.datos) {
            let value = _get_all_critical_levels.data.datos.filter(x => x.activo === true);
            setCriticalLevels(value);
        }
    }, [_get_all_critical_levels]);

    async function get_work_activity() {
        // eslint-disable-next-line
        let params = "?id=" + id;
        const response = await searchWorkActivity(token, params);
        try {
            if (response && response.data && response.data.cantidad > 0) {
                let data = response.data.datos[0];
                setForm(data);
                let options = data.equipos.map((item) => {
                    return {
                        value: item.id,
                        label: item.nombre,
                    };    
                });
                setTeamsSelect(options);
            }
        } catch (e) {
            console.log('Error')
        }
    }

    useEffect(() => {
        get_work_activity();
        // eslint-disable-next-line
    }, [id]);

    useEffect(() => {
        if (_get_all_teams.data.datos) {
            let val = _get_all_teams.data.datos.filter(x => x.activo === true && x.id_tipo_usuario ===  form.id_tipo_usuario);
            
            let options = val.map((item) => {
                return {
                    value: item.id,
                    label: item.nombre,
                };
            });
            setOptionsTeams(options);
        }
    }, [_get_all_teams, form]);


    useEffect(() => {
        if (_update_work_activity.status === 200) {
            dispatch(clear_work_activity(UPDATE_WORK_ACTIVITY));
            history.push(`/subproceso-trabajo/detalle/${id_work_sheet}/${id_work_process}/${id_work_subprocess}`);
            dispatch(getAllWorkSheets(token));
            setIsLoading(false);
        } else if (_update_work_activity.status !== 0) {
            dispatch(clear_work_activity(UPDATE_WORK_ACTIVITY));
            toast.error(_update_work_activity.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_update_work_activity, dispatch, history, token, id_work_sheet, id_work_process, id_work_subprocess]);

    
    const handleChange = (e) => {
        if (e.target.name === "id_nivel_critico") {
            setForm({
                ...form,
                [e.target.name]: parseInt(e.target.value),
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    };

    const handleCheckedChange = (checked) => {
        setForm({
            ...form,
            activo: checked,
        });
    };

    const handleCheckedRiskImpactChange = (checked) => {
        setForm({
            ...form,
            impacto_riesgo: checked,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (form.nombre === "") {
            toast.error("Debe ingresar el nombre", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        dispatch(updateWorkActivity(token, id, form));
    };

    const [optionsTeams, setOptionsTeams] = useState([]);
    const [teams_select, setTeamsSelect] = useState([]);

    const handleChangeSelect = (e) => {
        setTeamsSelect(e);
    };

    useEffect(() => {
        if (_create_work_activity_team.status === 201) {
            toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_work_activity(CREATE_WORK_ACTIVITY_TEAM));
            dispatch(getAllWorkSheets(token));
            get_work_activity();
            setIsLoading(false);
            setModalTeam(false);
        } else if (_create_work_activity_team.status !== 0) {
            dispatch(clear_work_activity(CREATE_WORK_ACTIVITY_TEAM));
            toast.error(_create_work_activity_team.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_create_work_activity_team, dispatch, history, token]);

    // eslint-disable-next-line
    const [data, setData] = useState({
        equipos: [],
    });

    const handleSubmitActivityTeam = (e) => {
        e.preventDefault();
        setIsLoading(true);
        let array = teams_select.map((item) => {
            return {
                id_equipo: item.value,
            };
        });
        data.equipos = array;
        if (data.equipos.length === 0) {
            toast.error("Debe seleccionar al menos un equipo", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }

        dispatch(createWorkActivityTeam(token, id, data));
    };

    useEffect(() => {
        if (_delete_work_activity_team.status === 200) {
            dispatch(clear_work_activity(DELETE_WORK_ACTIVITY_TEAM));
            dispatch(getAllWorkSheets(token));
            get_work_activity();
            setIsLoading(false);
        } else if (_delete_work_activity_team.status !== 0) {
            dispatch(clear_work_activity(DELETE_WORK_ACTIVITY_TEAM));
            toast.error(_delete_work_activity_team.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_delete_work_activity_team, dispatch, history, token]);


    function delete_item(idEquipo) {
        setIsLoading(true);
        dispatch(deleteWorkActivityTeam(token, idEquipo, id));
    }

    useEffect(() => {
        if (_create_work_activity_template.status === 201) {
            toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_work_activity_template(CREATE_WORK_ACTIVITY_TEMPLATE));
            dispatch(getAllWorkSheets(token));
            get_work_activity();
            setIsLoading(false);
            setModalTemplate(false);
        } else if (_create_work_activity_template.status !== 0) {
            dispatch(clear_work_activity_template(CREATE_WORK_ACTIVITY_TEMPLATE));
            toast.error(_create_work_activity_template.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_create_work_activity_template, dispatch, history, token]);

    useEffect(() => {
        if (_update_work_activity_template.status === 200) {
            toast.success("Actualizado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_work_activity_template(UPDATE_WORK_ACTIVITY_TEMPLATE));
            dispatch(getAllWorkSheets(token));
            get_work_activity();
            setIsLoading(false);
            setModalTemplate(false);
        } else if (_update_work_activity_template.status !== 0) {
            dispatch(clear_work_activity_template(UPDATE_WORK_ACTIVITY_TEMPLATE));
            toast.error(_update_work_activity_template.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_update_work_activity_template, dispatch, history, token]);

    const handleSubmitWorkActivityTemplate = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (nombre_archivo === '') {
            toast.error("Debe agregar el nombre del archivo", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (id_archivo === 0) {
            if (archivo === '') {
                toast.error("Debe seleccionar el archivo", {position: toast.POSITION.TOP_RIGHT});
                setIsLoading(false);
                return;
            }
            dispatch(createWorkActivityTemplate(token, {id_actividad: id, nombre: nombre_archivo, archivo: archivo}));
        } else {
            dispatch(updateWorkActivityTemplate(token, id_archivo ,{nombre: nombre_archivo, archivo: archivo}));
        }
    };

    useEffect(() => {
        if (_delete_work_activity_template.status === 200) {
            dispatch(clear_work_activity_template(DELETE_WORK_ACTIVITY_TEMPLATE));
            dispatch(getAllWorkSheets(token));
            get_work_activity();
            setIsLoading(false);
        } else if (_delete_work_activity_template.status !== 0) {
            dispatch(clear_work_activity_template(DELETE_WORK_ACTIVITY_TEMPLATE));
            toast.error(_delete_work_activity_template.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_delete_work_activity_template, dispatch, history, token]);

    function delete_template(id_template) {
        setIsLoading(true);
        dispatch(deleteWorkActivityTemplate(token, id_template));
    }

    useEffect(() => {
        if (_create_work_activity_aditional_data.status === 201) {
            toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_work_activity_aditional_data(CREATE_WORK_ACTIVITY_ADITIONAL_DATA));
            dispatch(getAllWorkSheets(token));
            get_work_activity();
            setIsLoading(false);
            setModalAditionalData(false);
        } else if (_create_work_activity_aditional_data.status !== 0) {
            dispatch(clear_work_activity_aditional_data(CREATE_WORK_ACTIVITY_ADITIONAL_DATA));
            toast.error(_create_work_activity_aditional_data.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_create_work_activity_aditional_data, dispatch, history, token]);

    const handleSubmitWorkActivityAditionalData = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (aditionalData === '') {
            toast.error("Debe agregar el dato adicional", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        dispatch(createWorkActivityAditionalData(token, {id_actividad: id, dato_adicional: aditionalData}));
    };

    useEffect(() => {
        if (_delete_work_activity_aditional_data.status === 200) {
            dispatch(clear_work_activity_aditional_data(DELETE_WORK_ACTIVITY_ADITIONAL_DATA));
            dispatch(getAllWorkSheets(token));
            get_work_activity();
            setIsLoading(false);
        } else if (_delete_work_activity_aditional_data.status !== 0) {
            dispatch(clear_work_activity_aditional_data(DELETE_WORK_ACTIVITY_ADITIONAL_DATA));
            toast.error(_delete_work_activity_aditional_data.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_delete_work_activity_aditional_data, dispatch, history, token]);

    function delete_aditional_data(id_aditional_data) {
        setIsLoading(true);
        dispatch(deleteWorkActivityAditionalData(token, id_aditional_data));
    }

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Hojas de trabajos"
                            items={[
                                {label: "Detalles", link: "/hojas-trabajos"},
                            ]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="row">
                        <div className="col-12">
                            <form className="card" onSubmit={handleSubmit}>
                                <div className="card-header">
                                    <h4 className="card-title">Actualizar actividades</h4>
                                </div>
                                <div className="card-body">
                                    <div><ToastContainer/></div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <Input
                                                name="nombre"
                                                label="Nombre"
                                                value={form.nombre}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Proceso de trabajo</label>
                                                <SelectInput
                                                    label="subproceso_trabajo"
                                                    name="id_subproceso_trabajo"
                                                    value={form.id_subproceso_trabajo}
                                                    select={form.subproceso_trabajo}
                                                    disabled={true}
                                                    options={[{
                                                        name: form.subproceso_trabajo,
                                                        id: form.id_subproceso_trabajo,
                                                    }]}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Nivel crítico</label>
                                                <SelectInput
                                                    id="id_nivel_critico"
                                                    label="nivel_critico"
                                                    name="id_nivel_critico"
                                                    value={form.id_nivel_critico}
                                                    select={form.nivel_critico}
                                                    onChange={handleChange}
                                                    options={criticalLevels ? criticalLevels.map((item) => ({
                                                        name: item.nombre,
                                                        id: item.id,
                                                    })) : []}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <Input
                                                name="puntos_critico"
                                                label="Puntos críticos"
                                                value={form.puntos_critico}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-md-12">
                                            <TextArea
                                                name="descripcion"
                                                label="Descripción"
                                                placeholder=""
                                                onChange={handleChange}
                                                rows={4}
                                                value={form.descripcion}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <Space size={14} direction='horizontal'>
                                                    <strong>Activo</strong>
                                                    <Switch
                                                        checked={form.activo}
                                                        checkedChildren="SI"
                                                        unCheckedChildren="NO"
                                                        onChange={handleCheckedChange}
                                                    />
                                                </Space>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <Space size={14} direction='horizontal'>
                                                    <strong>Riesgo de impacto</strong>
                                                    <Switch
                                                        checked={form.impacto_riesgo}
                                                        checkedChildren="SI"
                                                        unCheckedChildren="NO"
                                                        onChange={handleCheckedRiskImpactChange}
                                                    />
                                                </Space>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 mb-2">
                                            <p className="text-title">Equipos</p>
                                            <p className="text-body">Sección para asignar los equipos que deben realizar la actividad en la hoja de trabajo</p>
                                            <Button type="button" text="Agregar" theme="calendar" classes="mb-1" onChange={() => {
                                                // document.getElementById('id_equipo').selectedIndex = 0;
                                                setModalTeam(true);
                                            }}/>
                                        </div>
                                        {form.equipos.length > 0 && (
                                            form.equipos.map((item) => (
                                                <div className="col-md-6 col-12 mb-1">
                                                    <div className="d-flex p-1 border-card">
                                                        <div className="d-flex" style={{width: '90%'}}>
                                                            <div className="ml-1">
                                                                <span className="texto_20">{item.nombre}</span><br/>
                                                            </div>
                                                        </div>
                                                        <div className="text-right" style={{width: '10%'}}>
                                                            <img
                                                                src={window.location.origin + "/base/app-assets/images/icon/delete.png"}
                                                                alt="img"
                                                                height="20"
                                                                width="20"
                                                                onClick={() => {
                                                                    delete_item(item.id)
                                                                }}
                                                                style={{cursor: "pointer"}}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        )}
                                        <div className="col-12 mb-2">
                                            <p className="text-title">Plantillas</p>
                                            <p className="text-body">Sección para cargar las plantillas que serán necesarias para el cumplimiento de la actividad</p>
                                            <Button type="button" text="Agregar" theme="calendar" classes="mb-1" onChange={() => {
                                                setIdArchivo(0);
                                                setNombreArchivo('');
                                                setArchivo('');
                                                setModalTemplate(true);
                                            }}/>
                                        </div>
                                        {form.archivos.length > 0 && (
                                            form.archivos.map((item) => (
                                                <div className="col-md-6 col-12 mb-1">
                                                    <div className="d-flex p-1 border-card">
                                                        <div className="d-flex" style={{width: '80%'}}>
                                                            <div className="ml-1">
                                                                <span className="texto_20">{item.nombre}</span><br/>
                                                            </div>
                                                        </div>
                                                        <div className="text-right" style={{width: '20%'}}>
                                                            <img
                                                                src={window.location.origin + "/base/app-assets/images/icon/edit.png"}
                                                                alt="img"
                                                                height="20"
                                                                width="20"
                                                                onClick={() => {
                                                                    setIdArchivo(parseInt(item.id));
                                                                    setNombreArchivo(item.nombre);
                                                                    setArchivo('');
                                                                    setModalTemplate(true)
                                                                }}
                                                                style={{cursor: "pointer"}}
                                                            />
                                                            <img
                                                                src={window.location.origin + "/base/app-assets/images/icon/delete.png"}
                                                                alt="img"
                                                                height="20"
                                                                width="20"
                                                                onClick={() => {
                                                                    delete_template(item.id)
                                                                }}
                                                                style={{cursor: "pointer"}}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        )}
                                        <div className="col-12 mb-2">
                                            <p className="text-title">Datos adicionales</p>
                                            <p className="text-body">Sección para asignar los datos adicionales que se
                                                solicitarán al cumplir con la actividad</p>
                                            <Button type="button" text="Agregar" theme="calendar" classes="mb-1" onChange={() => {
                                                setAditionalData('');
                                                setModalAditionalData(true);
                                            }}/>
                                        </div>
                                        {form.datos_adicionales.length > 0 && (
                                            form.datos_adicionales.map((item) => (
                                                <div className="col-md-4 col-sm-6 col-12 mb-1">
                                                    <div className="d-flex p-1 border-card">
                                                        <div className="d-flex" style={{width: '90%'}}>
                                                            <div className="ml-1">
                                                                <span className="texto_20">{item.nombre}</span><br/>
                                                            </div>
                                                        </div>
                                                        <div className="text-right" style={{width: '10%'}}>
                                                            <img
                                                                src={window.location.origin + "/base/app-assets/images/icon/delete.png"}
                                                                alt="img"
                                                                height="20"
                                                                width="20"
                                                                onClick={() => {
                                                                    delete_aditional_data(item.id)
                                                                }}
                                                                style={{cursor: "pointer"}}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        )}
                                    </div>
                                    <div className="card-footer button_responsive">
                                        <Button text="Cancelar" onChange={() => {
                                            history.push(`/subproceso-trabajo/detalle/${id_work_sheet}/${id_work_process}/${id_work_subprocess}`);
                                        }} className="btn btn-outline-dark magin_button button_responsible"/>

                                        <Button type="submit" text="Guardar" theme="calendar" classes="button_responsible"/>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modalTeam}>
                <form onSubmit={handleSubmitActivityTeam}>
                    {isLoading && <LoadingSpinner/>}
                    <div className="card-body">
                        <h5 className="titulo_modal type_text mb-2">Agregar equipo</h5>
                        <div className="form-group">
                            <label>Equipos</label>
                            <Select
                                value={teams_select}
                                options={optionsTeams}
                                isMulti={true}
                                onChange={handleChangeSelect}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} className={`btn btn-calendar mb-1 button_div`}>Guardar</button>
                        <button type="button" onClick={() => {
                            setModalTeam(false);
                        }} className={`btn btn-outline-calendar button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Modal className="modal-main div-modal" show={modalTemplate}>
                <form onSubmit={handleSubmitWorkActivityTemplate}>
                    {isLoading && <LoadingSpinner/>}
                    <div className="card-body">
                        <h5 className="titulo_modal type_text mb-2">{id_archivo === 0 ? 'Agregar ' : 'Modificar '} archivo</h5>
                        <div className="form-group">
                            <Input
                                name="nombre_archivo"
                                label="Nombre de archivo"
                                value={nombre_archivo}
                                onChange={(e) => {setNombreArchivo(e.target.value)}}
                            />
                        </div>
                        <div className="form-group">
                            <Input
                                id="archivo"
                                name="archivo"
                                label="archivo"
                                type="file"
                                onChange={(e) => {setArchivo(e.target.files[0])}}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} className={`btn btn-calendar mb-1 button_div`}>Guardar</button>
                        <button type="button" onClick={() => {
                            setModalTemplate(false);
                        }} className={`btn btn-outline-calendar button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Modal className="modal-main div-modal" show={modalAditionalData}>
                <form onSubmit={handleSubmitWorkActivityAditionalData}>
                    {isLoading && <LoadingSpinner/>}
                    <div className="card-body">
                        <h5 className="titulo_modal type_text mb-2">Agregar dato adicional</h5>
                        <div className="form-group">
                            <Input
                                name="aditionalData"
                                label="nombre"
                                value={aditionalData}
                                onChange={(e) => {setAditionalData(e.target.value)}}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} className={`btn btn-calendar mb-1 button_div`}>Guardar</button>
                        <button type="button" onClick={() => {
                            setModalAditionalData(false);
                        }} className={`btn btn-outline-calendar button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Footer/>
        </div>
    );
};

export default UpdateWorkActivity;
